export const airdropStates = {
  claimed: 'claimed',
  eligible: 'eligible',
  notEligible: 'not_eligible'
}

export const favoriteTypes = {
  sale: 'sale',
  assetPair: 'asset_pair'
}

export { blobTypes, blobFilters, documentTypes, MAX_FILE_MEGABYTES, MAX_FILE_BYTES } from './documents.const'
export { SECONDARY_MARKET_ORDER_BOOK_ID } from './offers.const'
export { walletTokens, brokenTokenCodes } from './tokens.const'
export { feeAsset, withdrawalFeeETH } from './fees.const'
export { saleTypes, saleSortTypes, saleStates, saleGetList } from './sales.const'
export { userStates, userTypes, KYC_USER_TYPE } from './user.const'
export { defaultSignerParams } from './signers.const'
export { localStorageKeys } from './common.const'
export { ROUNDING_MODES } from './numbers.const'
export { CREATE_TOKEN_REQUEST_STATES } from './create_token_request_states'
export { ISSUANCE_REQUEST_STATES } from './issuance_request_states.const'
export { REQUEST_STATES, REQUEST_STATES_STR } from './request_states.const'
export { REVIEW_TASKS_INDEX } from './review_tasks.const'
export { SIGNER_TYPES } from './signer_types.const'
export { ACCOUNT_STATES } from './account.const'
export { DOCUMENT_POLICIES } from './document-policies.const'
export { LIMIT_OPS, LIMIT_OPS_STR, LIMITS_REQUEST_TYPE, LIMITS_REQUEST_TYPE_STR } from './limits.const'
export { CONTRACTS_DETAILS_TYPES } from './contracts.const'
export { USERS_FILTER_NAME } from './filters.const'

export {
  REQUEST_TYPES,
  FEE_TYPES,
  ASSET_POLICIES,
  ASSET_POLICIES_VERBOSE,
  ASSET_PAIR_POLICIES,
  STATS_OPERATION_TYPES,
  ACCOUNT_TYPES,
  CONTRACT_STATES,
  PAYMENT_FEE_SUBTYPES
} from './xdr.const'

export {
  DEFAULT_BASE_ASSET,
  DEFAULT_CONVERSION_ASSET,
  DEFAULT_QUOTE_ASSET,
  DEFAULT_PRECISION,
  DEFAULT_INPUT_STEP,
  DEFAULT_INPUT_MIN,
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_TIME_FORMAT,
  DEFAULT_MAX_AMOUNT,
  XPAY_NON_VISIBLE_TYPE,
  WITHDRAWAL_TYPE_EMPTY,
  WITHDRAWAL_TYPE_NOT_EMPTY
} from './configs.const'
export { assetMap, hiddenAssets, filterHiddenAssets } from './asset_map'
export { ORDER_TYPES } from './order-types'



// WEBPACK FOOTER //
// ./src/js/const/index.js